import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, Switch } from "antd";
import isEqual from "lodash.isequal";
import dayjs from "dayjs";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import reservationsActions from "../../../redux/reservations/actions";
import ReservationComponent from "../../../components/User/ReservationComponent/ReservationComponent";
import DatePickerComponent from "./DatePickerComponent";
import { useProjectState } from "../../../context/stateContext";
import "./index.css";

const { getRegions, getReservationTable } = restaurantSchemaActions;
const { getReservationsPerRegion } = reservationsActions;

const Reservations = () => {
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState();
  const [date, setDate] = useState(dayjs());
  const [items, setItems] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const initialLoadDone = useRef(false);

  const { regions } = useSelector((state) => state.restaurantSchemaReducer);

  const {
    showSeatedTimeForReservationTable,
    setShowSeatedTimeForReservationTable,
  } = useProjectState();

  // Fetch regions once on mount
  useEffect(() => {
    dispatch(getRegions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // When regions arrive, set items and activeKey (only if changed)
  useEffect(() => {
    if (!isEqual(items, regions) && regions.length > 0) {
      setItems(regions);
      const exists = regions.some((region) => region.key === activeKey);
      if (!exists) {
        setActiveKey(regions[0].key);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regions]);

  // Single consolidated fetch for tables + reservations
  const fetchData = useCallback(() => {
    if (!activeKey) return;
    dispatch(getReservationTable(activeKey));
    dispatch(
      getReservationsPerRegion({
        organizationId: parseInt(localStorage.getItem("organizationId")),
        regionId: null,
        date: date.format("YYYY-MM-DD"),
      })
    );
  }, [activeKey, date, dispatch]);

  // Fetch data when activeKey or date changes + set up single polling interval
  useEffect(() => {
    if (!activeKey) return;
    fetchData();
    initialLoadDone.current = true;
    const intervalId = setInterval(fetchData, 60000);
    return () => clearInterval(intervalId);
  }, [activeKey, date, fetchData]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onChange = (newActiveKey) => {
    setActiveKey(newActiveKey);
  };

  // Replace the old children with new one
  items.forEach((item) => {
    item.children = (
      <ReservationComponent
        backgroundImage={item.backgroundImage}
        regionId={activeKey}
        date={date}
      />
    );
  });

  return (
    <>
      {screenWidth < 768 && (
        <div className="reservation-date-picker-container">
          <DatePickerComponent date={date} setDate={setDate} />
        </div>
      )}
      <Tabs
        tabBarExtraContent={
          screenWidth >= 768 && (
            <div className="reservation-switch-table-details">
              <Switch
                className="reservation-switch-custom"
                checkedChildren={<span>Заетост на масите</span>}
                unCheckedChildren={<span>Имена на масите</span>}
                checked={showSeatedTimeForReservationTable}
                onChange={(value) =>
                  setShowSeatedTimeForReservationTable(value)
                }
              />
              <DatePickerComponent date={date} setDate={setDate} />
            </div>
          )
        }
        onChange={onChange}
        type="card"
        activeKey={activeKey}
        items={items}
      />
    </>
  );
};
export default Reservations;
